import DefaultOne from "../../images/defaultProfile/default-1_500x500.png";
import DefaultTwo from "../../images/defaultProfile/default-2_500x500.png";
import DefaultThree from "../../images/defaultProfile/default-3_500x500.png";
import DefaultFour from "../../images/defaultProfile/default-4_500x500.png";

export const validateSocialMedia = (
  type: string,
  input: string
): string | undefined => {
  if (input) {
    let error = undefined;
    switch (type) {
      case "twitter":
        if (!input.startsWith("twitter.com/")) {
          error = "Format: twitter.com/USERNAME";
        }
        break;
      case "discord":
        if (!/^.+#\d{4}$/.test(input)) {
          error = "Format: [username]#0000";
        }
        break;
      case "youtube":
        if (
          !input.startsWith("youtube.com/channel/") &&
          !input.startsWith("youtube.com/c/")
        ) {
          error =
            "Format: youtube.com/channel/CHANNEL_NAME or youtube.com/c/CHANNEL_NAME";
        }
        break;
      case "opensea":
        if (!input.startsWith("opensea.io/")) {
          error = "Format: opensea.io/USERNAME";
        }
        break;
      case "foundation":
        if (!input.startsWith("foundation.app/")) {
          error = "Format: foundation.app/USERNAME";
        }
        break;
      default:
      //No need for validation if it's not something we support
      //do nothing
    }

    return error;
  } else {
    return undefined;
  }
};
export const shortenUsername = (username: string) => {
  try {
    if (typeof username !== "string") {
      return null;
    } else if (username && username.length > 18) {
      return `${username.slice(0, 18)}...`;
    } else {
      return username;
    }
  } catch {
    return null;
  }
};
// takes in a user object and returns a username if available or formatted wallet address
export const addressOrUsername = (user) => {
  try {
    if (user.username) {
      if (user.username.username) {
        return shortenUsername(user.username.username);
      } else if (typeof user.username === "string") {
        return shortenUsername(user.username);
      } else {
        return `${user.address.slice(0, 4)}...${user.address.slice(-4)}`;
      }
    } else {
      return `${user.address.slice(0, 4)}...${user.address.slice(-4)}`;
    }
  } catch {
    return null;
  }
};

// randomly assigns a user with a profile image based on the last number in the users wallet addrses
export const randomProfilePic = (userAddress: string) => {
  const regEx = new RegExp("\\d+(?=\\D*$)");
  const lastNum = regEx.exec(userAddress)[0];
  switch (lastNum % 4) {
    case 0:
      return DefaultOne;
    case 1:
      return DefaultTwo;
    case 2:
      return DefaultThree;
    case 3:
      return DefaultFour;
    default:
      return DefaultOne;
  }
};
